import {useEffect, useState} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';
import {useConversationUIFeatureFlags} from '../FeatureFlagsProvider';

export function useMessagesTopAnchored(conversation: Conversation): {
  isTopAnchoredEnabled: boolean;
  shouldTopAnchor: boolean;
} {
  const {newUniversalHelpDesign, messagesTopAnchored} =
    useConversationUIFeatureFlags();

  const [disabled, setDisabled] = useState(
    conversation.context.channel === 'chat' ||
      conversation.context.requestedChannel === 'chat',
  );

  useEffect(() => {
    const sub = conversation.contextObservable().subscribe(() => {
      // Handles when the conversation context, and thus the channel, changes
      setDisabled(
        conversation.context.channel === 'chat' ||
          conversation.context.requestedChannel === 'chat',
      );
    });
    return () => sub.unsubscribe();
  }, [conversation]);

  const isTopAnchoredEnabled = !!(
    messagesTopAnchored && newUniversalHelpDesign
  );

  // We have to different types of "enabled": whether flag is on to
  // enable this feature entirely, or if we've manually turned it off.
  // We need both so in the case where we turn it off, we still keep
  // some of the structure in place to keep it working
  return {
    isTopAnchoredEnabled,
    shouldTopAnchor: isTopAnchoredEnabled && !disabled,
  };
}
